import { render } from "./SVGOptions.vue?vue&type=template&id=66177500"
import script from "./SVGOptions.vue?vue&type=script&lang=js"
export * from "./SVGOptions.vue?vue&type=script&lang=js"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__